module.exports = __webpack_public_path__ + "img/img_certification_mark_03.68311c3.svg";